import useSWR from 'swr'

import { API_URL } from "../Const"

import axios from "axios"


const fetcher = (url : string) => {
  let jsonlist = JSON.parse(localStorage.getItem("datalist") || '{}')
  return axios.post(url,
    {
      "company_id": jsonlist.user.company_id,
    },
    { headers: { Authorization: jsonlist.token.IdToken } },

  )
    .then(res => res.data)
}

export function useCheckLists() {
  const {data, error, mutate} = useSWR(API_URL.CHECKLIST_LIST, fetcher)
  return {
    checkLists : data?.data,
    error,
    mutateCheckLists : mutate
  }
}